const PAGE_SIZE = 24;
const collator = new Intl.Collator('en', {numeric: true, sensitivity: 'base'});
export const list = value => {
  try { const v = JSON.parse(value || 'null'); return [...new Set((Array.isArray(v) ? v : [v]).filter(x => typeof x === 'string' && x.trim()).map(x => x.trim()))]; }
  catch { return []; }
};
export const state = url => ({brand: url.searchParams.get('badge_brand') || '', model: url.searchParams.get('badge_model') || '', logo: url.searchParams.get('badge_logo') || '', page: Math.max(1, Math.floor(Number(url.searchParams.get('badge_page') || url.searchParams.get('page')) || 1))});
export const matches = (row, s, ignore) => (ignore === 'model' || !s.model || row.models.includes(s.model)) && (ignore === 'logo' || !s.logo || row.logos.includes(s.logo));
export const values = (rows, field) => [...new Set(rows.flatMap(row => row[field === 'model' ? 'models' : 'logos']))].sort(collator.compare);
export const change = (url, field, value) => {
  const u = new URL(url); u.searchParams.delete('page'); u.searchParams.delete('badge_page');
  if (field === 'reset') { u.searchParams.delete('badge_brand'); u.searchParams.delete('badge_model'); u.searchParams.delete('badge_logo'); }
  else if (field === 'brand') {
    if (value) u.searchParams.set('badge_brand', new URL(value, u).pathname);
    else u.searchParams.delete('badge_brand');
    u.searchParams.delete('badge_model'); u.searchParams.delete('badge_logo');
  }
  else if (field === 'sort') { value ? u.searchParams.set('sort_by', value) : u.searchParams.delete('sort_by'); }
  else { value ? u.searchParams.set('badge_' + field, value) : u.searchParams.delete('badge_' + field); }
  return u;
};
export const requestUrl = (url, sectionId, collectionUrl) => {
  const u = new URL(url); u.pathname = new URL(collectionUrl, u).pathname;
  for (const key of [...u.searchParams.keys()]) if (key.startsWith('badge_') || key.startsWith('filter.') || key === 'page') u.searchParams.delete(key);
  u.searchParams.set('section_id', sectionId); return u;
};
const plainClick = e => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
const relative = url => url.pathname + url.search + url.hash;
export const rowsOf = (root, selector = '[data-badge-products]') => [...root.querySelectorAll(selector + ' [data-product-id]')].map(node => ({id: node.dataset.productId, node, models: list(node.dataset.badgeModels), logos: list(node.dataset.badgeLogos)}));
const detailsOf = root => [...root.querySelectorAll('details.acura-filter-list')];
function closeMenus(root, except) { detailsOf(root).forEach(d => { if (d !== except) d.open = false; }); }
function searchOptions(details) {
  const q = details.querySelector('[data-badge-search]')?.value.trim().toLocaleLowerCase() || '';
  const options = [...details.querySelectorAll('[data-badge-option], [data-badge-brand-link]')];
  options.forEach(node => { node.hidden = !node.textContent.toLocaleLowerCase().includes(q); });
  const empty = details.querySelector('[data-badge-search-empty]');
  if (empty) empty.hidden = options.some(node => !node.hidden);
}
function bindMenus(root) {
  if (root.dataset.badgeMenuBound) return;
  root.dataset.badgeMenuBound = 'true';
  root.addEventListener('click', e => { if (e.target.closest('summary[aria-disabled="true"]')) e.preventDefault(); });
  root.addEventListener('input', e => { if (e.target.matches('[data-badge-search]')) searchOptions(e.target.closest('details')); });
  root.addEventListener('toggle', e => { if (e.target.matches('details.acura-filter-list') && e.target.open) closeMenus(root, e.target); }, true);
  root.addEventListener('keydown', e => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('summary[aria-disabled="true"]')) { e.preventDefault(); return; }
    if (e.key === 'Escape') { const d = e.target.closest('details[open]'); if (d) { e.preventDefault(); d.open = false; d.querySelector('summary').focus(); } }
  });
  document.addEventListener('click', e => { if (!root.contains(e.target)) closeMenus(root); });
}
function initCatalog(root) {
  if (root.dataset.badgeBound) return;
  root.dataset.badgeBound = 'true'; bindMenus(root);
  const grid = root.querySelector('[data-badge-products]'), pager = root.querySelector('[data-badge-pagination]');
  const count = root.querySelector('[data-badge-count]'), status = root.querySelector('[data-badge-status]');
  const sort = root.querySelector('[data-badge-sort]'), reset = root.querySelector('[data-badge-reset]');
  const controls = [...root.querySelectorAll('[data-badge-control]')];
  const allowedSorts = new Set([...sort.options].map(x => x.value));
  const defaultSort = root.dataset.defaultSort || root.dataset.sort;
  const cache = new Map(); let controller, serial = 0, desired = new URL(location.href);
  const effectiveSort = u => allowedSorts.has(u.searchParams.get('sort_by')) ? u.searchParams.get('sort_by') : defaultSort;
  const error = (message, retry) => {
    status.replaceChildren(); status.hidden = !message;
    if (message) status.append(document.createTextNode(message + ' '));
    if (retry) { const b = document.createElement('button'); b.type = 'button'; b.textContent = 'Try again'; b.addEventListener('click', () => update(new URL(desired), false)); status.append(b); }
  };
  async function load(url, signal) {
    const key = effectiveSort(url); if (cache.has(key)) return cache.get(key);
    const base = requestUrl(url, root.dataset.sectionId, root.dataset.collectionUrl); base.searchParams.set('sort_by', key);
    let all = [], total = null, pages = 1;
    for (let page = 1; page <= pages; page++) {
      const u = new URL(base); if (page > 1) u.searchParams.set('page', page);
      const response = await fetch(u, {signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Collection request failed: ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-lds-badge-catalog]');
      if (!fresh || fresh.dataset.collectionUrl !== root.dataset.collectionUrl) throw new Error('Wrong collection response');
      const actualTotal = Number(fresh.dataset.total), actualPages = Number(fresh.dataset.pages);
      if (!Number.isInteger(actualTotal) || actualTotal < 0 || !Number.isInteger(actualPages) || actualPages < 1 || actualPages > 100) throw new Error('Invalid collection size');
      if (total === null) { total = actualTotal; pages = actualPages; }
      else if (total !== actualTotal || pages !== actualPages) throw new Error('Collection changed during loading');
      if (Number(fresh.dataset.serverPage) !== page) throw new Error('Unexpected collection page');
      all.push(...rowsOf(fresh));
    }
    const ids = new Set(all.map(row => row.id));
    if (ids.size !== all.length || all.length !== total) throw new Error('Incomplete collection response');
    if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
    cache.set(key, all); return all;
  }
  function render(rows, url) {
    for (const field of ['model', 'logo']) { const selected = url.searchParams.get('badge_' + field); if (selected && !values(rows, field).includes(selected)) { url.searchParams.delete('badge_' + field); url.searchParams.delete('badge_page'); url.searchParams.delete('page'); } }
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.')) url.searchParams.delete(key);
    if (url.searchParams.has('sort_by')) url.searchParams.set('sort_by', effectiveSort(url));
    const s = state(url), matched = rows.filter(row => matches(row, s));
    const pages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE)); const page = Math.min(s.page, pages);
    url.searchParams.delete('page'); page > 1 ? url.searchParams.set('badge_page', String(page)) : url.searchParams.delete('badge_page');
    const shown = new Set(matched.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map(row => row.id));
    const fragment = document.createDocumentFragment();
    rows.forEach(row => { row.node.hidden = !shown.has(row.id); fragment.append(row.node); }); grid.replaceChildren(fragment);
    count.textContent = matched.length + ' products';
    root.querySelector('[data-badge-empty]').hidden = matched.length > 0;
    for (const detail of controls) {
      const field = detail.dataset.badgeControl, selected = s[field], opts = values(rows, field), box = detail.querySelector('[data-badge-options]');
      detail.hidden = field === 'model' && !opts.length;
      detail.dataset.state = !opts.length && !selected ? 'unavailable' : 'available';
      detail.querySelector('summary').setAttribute('aria-disabled', String(!opts.length && !selected));
      if (!opts.length && !selected) { detail.open = false; detail.querySelector('summary').setAttribute('aria-description', 'No confirmed ' + field + ' choices are available.'); } else detail.querySelector('summary').removeAttribute('aria-description');
      detail.querySelector('[data-badge-selected]').textContent = selected || 'Select ' + field;
      const previousFocus = box.contains(document.activeElement);
      box.replaceChildren();
      const add = (value, label, n) => {
        const line = document.createElement('label'), input = document.createElement('input'), text = document.createElement('span');
        line.dataset.badgeOption = ''; input.type = 'radio'; input.name = 'badge_' + field; input.value = value; input.dataset.badgeField = field; input.checked = selected === value;
        input.disabled = value !== '' && n === 0 && selected !== value;
        text.textContent = label + (value ? ' (' + n + ')' : ''); line.append(input, text); box.append(line);
      };
      add('', 'All · Reset', rows.filter(row => matches(row, {...s, [field]: ''})).length);
      for (const v of opts) add(v, v, rows.filter(row => matches(row, s, field) && row[field === 'model' ? 'models' : 'logos'].includes(v)).length);
      
      if (!opts.length) { const note = document.createElement('p'); note.className = 'badge-catalog-help'; note.textContent = 'No confirmed ' + field + ' choices are available.'; box.append(note); }
      if (previousFocus) detail.querySelector('summary').focus();
      searchOptions(detail);
    }
    pager.replaceChildren(); pager.hidden = pages < 2;
    for (let n = 1; n <= pages && pages > 1; n++) {
      const a = document.createElement('a'), target = new URL(url); target.searchParams.delete('badge_page'); if (n > 1) target.searchParams.set('badge_page', String(n));
      a.href = relative(target); a.textContent = String(n); a.setAttribute('aria-label', 'Page ' + n); if (n === page) a.setAttribute('aria-current', 'page'); pager.append(a);
    }
    const clear = change(url, 'reset'); reset.href = relative(clear); reset.hidden = !(s.model || s.logo);
    sort.value = effectiveSort(url); root.dataset.badgeReady = 'true'; root.dataset.badgeMatched = String(matched.length); root.dataset.badgeLoaded = String(rows.length);
    return url;
  }
  async function update(url, push = true) {
    if (url.origin !== location.origin || url.pathname !== root.dataset.collectionUrl) return;
    desired = new URL(url); const mine = ++serial; controller?.abort(); controller = new AbortController();
    root.setAttribute('aria-busy', 'true'); error('Loading products…', false);
    try {
      const rows = await load(url, controller.signal); if (mine !== serial) return;
      const normalized = render(rows, new URL(url)); desired = normalized;
      if (push && relative(normalized) !== relative(new URL(location.href))) history.pushState({}, '', normalized); else history.replaceState(history.state, '', normalized);
      error('', false); root.removeAttribute('aria-busy');
    } catch (e) { if (mine !== serial || e.name === 'AbortError') return; root.removeAttribute('aria-busy'); error('Products could not be loaded. Your selection has not been applied.', true); root.dataset.badgeReady = 'error'; }
  }
  root.addEventListener('change', e => {
    if (e.target.matches('[data-badge-field]')) { const d = e.target.closest('details'); d.open = false; d.querySelector('summary').focus(); update(change(desired, e.target.dataset.badgeField, e.target.value)); }
    else if (e.target === sort) update(change(desired, 'sort', sort.value));
  });
  root.addEventListener('click', e => {
    const link = e.target.closest('[data-badge-pagination] a, [data-badge-reset], [data-badge-clear]');
    if (!link || !plainClick(e)) return; e.preventDefault(); closeMenus(root);
    update(link.matches('[data-badge-clear]') ? change(desired, 'reset') : new URL(link.href));
  });
  window.addEventListener('popstate', () => { if (location.pathname === root.dataset.collectionUrl) update(new URL(location.href), false); });
  const initial = rowsOf(root), total = Number(root.dataset.total);
  const nativeFilters = [...desired.searchParams.keys()].some(k => k.startsWith('filter.'));
  if (!nativeFilters && Number(root.dataset.serverPage) === 1 && initial.length === total && new Set(initial.map(x => x.id)).size === total) cache.set(root.dataset.sort, initial);
  update(desired, false);
}

const collectionPath = value => {
  try { return new URL(value, typeof location === 'undefined' ? 'https://leddoorsills.local/' : location.href).pathname; }
  catch { return ''; }
};
export const hubCacheKey = (brandUrl, sort) => collectionPath(brandUrl) + '::' + sort;
const hubGeneralKey = (sort, page) => 'general::' + sort + '::' + page;
const HUB_SERVER_PAGE_SIZE = 250;

function initHub(root) {
  if (root.dataset.badgeHubBound) return;
  const catalog = root.querySelector('[data-badge-hub-catalog]');
  const grid = catalog?.querySelector('[data-badge-hub-products]');
  if (!catalog || !grid) return;
  root.dataset.badgeHubBound = 'true';
  bindMenus(root);

  const picker = root.querySelector('[data-badge-hub-picker]');
  const brandControl = picker?.querySelector('[data-badge-hub-control="brand"]');
  const modelControl = picker?.querySelector('[data-badge-hub-control="model"]');
  const pager = catalog.querySelector('[data-badge-hub-pagination], [data-badge-pagination]');
  const count = catalog.querySelector('[data-badge-hub-count]');
  const status = catalog.querySelector('[data-badge-hub-status]');
  const empty = catalog.querySelector('[data-badge-hub-empty]');
  const reset = catalog.querySelector('[data-badge-hub-reset]');
  const sort = catalog.querySelector('[data-badge-hub-sort-select], [data-badge-sort]');
  if (!picker || !brandControl || !modelControl || !pager || !count || !status || !empty || !reset || !sort) return;

  const allowedSorts = new Set([...sort.options].map(option => option.value));
  const defaultSort = catalog.dataset.defaultSort || catalog.dataset.sort;
  const effectiveSort = url => allowedSorts.has(url.searchParams.get('sort_by')) ? url.searchParams.get('sort_by') : defaultSort;
  const initialRows = rowsOf(catalog, '[data-badge-hub-products]');
  const generalCache = new Map();
  const brandCache = new Map();
  const initialPage = Math.max(1, Number(catalog.dataset.serverPage) || 1);
  const initialTotal = Number(catalog.dataset.total);
  generalCache.set(hubGeneralKey(effectiveSort(new URL(location.href)), initialPage), {
    rows: initialRows,
    total: Number.isInteger(initialTotal) && initialTotal >= 0 ? initialTotal : initialRows.length,
    pages: Math.max(1, Number(catalog.dataset.pages) || 1),
    serverPage: initialPage,
    sectionId: catalog.dataset.sectionId,
    sort: effectiveSort(new URL(location.href)),
    paginationHTML: pager.innerHTML
  });

  let controller;
  let serial = 0;
  let desired = new URL(location.href);

  const setStatus = (message, retry) => {
    status.replaceChildren();
    status.hidden = !message;
    if (message) status.append(document.createTextNode(message + (retry ? ' ' : '')));
    if (retry) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Try again';
      button.addEventListener('click', () => update(new URL(desired), false));
      status.append(button);
    }
  };

  const brandLinks = () => [...picker.querySelectorAll('[data-badge-brand-link]')];
  const brandLinkFor = value => {
    const path = collectionPath(value);
    return brandLinks().find(link => collectionPath(link.href) === path) || null;
  };
  const replaceRows = (rows, shown) => {
    const visible = shown ? new Set(shown.map(row => row.id)) : null;
    const fragment = document.createDocumentFragment();
    rows.forEach(row => { row.node.hidden = visible ? !visible.has(row.id) : false; fragment.append(row.node); });
    grid.replaceChildren(fragment);
  };
  const renderPager = (url, pages, page, mode) => {
    pager.replaceChildren();
    pager.hidden = pages < 2;
    for (let number = 1; number <= pages && pages > 1; number++) {
      const target = new URL(url);
      target.searchParams.delete('page');
      target.searchParams.delete('badge_page');
      if (mode === 'brand') {
        if (number > 1) target.searchParams.set('badge_page', String(number));
      } else if (number > 1) target.searchParams.set('page', String(number));
      const link = document.createElement('a');
      link.href = relative(target);
      link.textContent = String(number);
      link.setAttribute('aria-label', 'Page ' + number);
      if (number === page) link.setAttribute('aria-current', 'page');
      pager.append(link);
    }
  };
  const renderModelOptions = (rows, selected, hasBrand) => {
    const box = modelControl.querySelector('[data-badge-options]');
    const summary = modelControl.querySelector('summary');
    const selectedText = modelControl.querySelector('[data-badge-selected]');
    const previousFocus = box.contains(document.activeElement);
    const options = hasBrand ? values(rows, 'model') : [];
    box.replaceChildren();
    if (!hasBrand) {
      modelControl.hidden = false;
      modelControl.dataset.state = 'unavailable';
      summary.setAttribute('aria-disabled', 'true');
      summary.setAttribute('aria-description', 'Select a brand before choosing a model.');
      selectedText.textContent = 'Select brand first';
      const note = document.createElement('p');
      note.className = 'badge-catalog-help';
      note.textContent = 'Select a brand first.';
      box.append(note);
    } else if (!options.length) {
      modelControl.hidden = true;
      modelControl.dataset.state = 'unavailable';
      modelControl.open = false;
      summary.setAttribute('aria-disabled', 'true');
      summary.setAttribute('aria-description', 'No confirmed model choices are available for this brand.');
      selectedText.textContent = 'No confirmed models';
    } else {
      modelControl.hidden = false;
      modelControl.dataset.state = 'available';
      summary.setAttribute('aria-disabled', 'false');
      summary.removeAttribute('aria-description');
      selectedText.textContent = selected || 'Select model';
      const add = (value, label, total) => {
        const line = document.createElement('label');
        const input = document.createElement('input');
        const text = document.createElement('span');
        line.dataset.badgeOption = '';
        input.type = 'radio';
        input.name = 'badge_model';
        input.value = value;
        input.dataset.badgeField = 'model';
        input.dataset.badgeHubField = 'model';
        input.checked = selected === value;
        text.textContent = label + (value ? ' (' + total + ')' : '');
        line.append(input, text);
        box.append(line);
      };
      add('', 'All · Reset', rows.length);
      for (const value of options) add(value, value, rows.filter(row => row.models.includes(value)).length);
    }
    if (previousFocus && !modelControl.hidden) summary.focus();
    searchOptions(modelControl);
  };
  const renderControls = (rows, url, brandLink) => {
    const current = state(url);
    const brandSelected = brandControl.querySelector('[data-badge-selected]');
    const brandSummary = brandControl.querySelector('summary');
    brandSelected.textContent = brandLink?.querySelector('span')?.textContent.trim() || 'Select brand';
    brandControl.dataset.state = 'available';
    brandSummary.setAttribute('aria-disabled', 'false');
    brandSummary.removeAttribute('aria-description');
    renderModelOptions(rows, current.model, Boolean(current.brand));
    searchOptions(brandControl);
  };
  const validatePage = (fresh, expectedPath, page, maximum) => {
    if (!fresh || collectionPath(fresh.dataset.collectionUrl) !== expectedPath) throw new Error('Wrong collection response');
    const total = Number(fresh.dataset.total);
    const pages = Number(fresh.dataset.pages);
    const serverPage = Number(fresh.dataset.serverPage);
    if (!Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages < 1 || pages > 100 || serverPage !== page) throw new Error('Invalid collection page');
    const rows = rowsOf(fresh);
    if (rows.length > maximum || new Set(rows.map(row => row.id)).size !== rows.length) throw new Error('Invalid product rows');
    return {rows, total, pages, serverPage, sectionId: fresh.dataset.sectionId || ''};
  };
  const readDocument = async (url, signal) => {
    const response = await fetch(url, {signal, credentials: 'same-origin'});
    if (!response.ok) throw new Error('Collection request failed: ' + response.status);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };
  const brandPage = async (brandPath, sortValue, page, sectionId, signal) => {
    const expectedPath = collectionPath(brandPath);
    const sectionUrl = requestUrl(new URL(location.href), sectionId, expectedPath);
    sectionUrl.searchParams.set('sort_by', sortValue);
    if (page > 1) sectionUrl.searchParams.set('page', String(page));
    let doc = await readDocument(sectionUrl, signal);
    let fresh = doc.querySelector('[data-lds-badge-catalog]');
    let nextSectionId = sectionId;
    if (!fresh || collectionPath(fresh.dataset.collectionUrl) !== expectedPath) {
      if (page !== 1) throw new Error('Brand collection section unavailable');
      const fullUrl = new URL(location.href);
      fullUrl.pathname = expectedPath;
      for (const key of [...fullUrl.searchParams.keys()]) if (key.startsWith('badge_') || key.startsWith('filter.') || key === 'page' || key === 'section_id') fullUrl.searchParams.delete(key);
      fullUrl.searchParams.set('sort_by', sortValue);
      doc = await readDocument(fullUrl, signal);
      fresh = doc.querySelector('[data-lds-badge-catalog]');
      if (!fresh || collectionPath(fresh.dataset.collectionUrl) !== expectedPath) throw new Error('Brand collection response unavailable');
      nextSectionId = fresh.dataset.sectionId || '';
    }
    if (fresh.dataset.sectionId) nextSectionId = fresh.dataset.sectionId;
    if (!nextSectionId) throw new Error('Brand collection section id unavailable');
    return {...validatePage(fresh, expectedPath, page, HUB_SERVER_PAGE_SIZE), sectionId: nextSectionId};
  };
  const loadBrand = async (brandPath, sortValue, signal) => {
    const key = hubCacheKey(brandPath, sortValue);
    if (brandCache.has(key)) return brandCache.get(key);
    let sectionId = catalog.dataset.sectionId || '';
    let total = null;
    let pages = 1;
    const all = [];
    for (let page = 1; page <= pages; page++) {
      const result = await brandPage(brandPath, sortValue, page, sectionId, signal);
      if (sectionId && result.sectionId !== sectionId && page > 1) throw new Error('Brand collection section changed');
      sectionId = result.sectionId;
      if (total === null) { total = result.total; pages = result.pages; }
      else if (total !== result.total || pages !== result.pages) throw new Error('Brand collection changed during loading');
      all.push(...result.rows);
    }
    if (new Set(all.map(row => row.id)).size !== all.length || all.length !== total) throw new Error('Incomplete brand collection response');
    const loaded = {rows: all, total, pages, sectionId, sort: sortValue};
    brandCache.set(key, loaded);
    return loaded;
  };
  const loadGeneral = async (url, signal) => {
    const sortValue = effectiveSort(url);
    const page = state(url).page;
    const key = hubGeneralKey(sortValue, page);
    if (generalCache.has(key)) return generalCache.get(key);
    const sectionUrl = requestUrl(url, catalog.dataset.sectionId, catalog.dataset.collectionUrl);
    sectionUrl.searchParams.set('sort_by', sortValue);
    if (page > 1) sectionUrl.searchParams.set('page', String(page));
    const doc = await readDocument(sectionUrl, signal);
    const fresh = doc.querySelector('[data-badge-hub-catalog]');
    const result = validatePage(fresh, collectionPath(catalog.dataset.collectionUrl), page, PAGE_SIZE);
    const loaded = {...result, sort: sortValue, paginationHTML: fresh.querySelector('[data-badge-hub-pagination]')?.innerHTML || ''};
    generalCache.set(key, loaded);
    return loaded;
  };
  const renderGeneral = (result, url) => {
    const normalized = new URL(url);
    const current = state(normalized);
    normalized.searchParams.delete('badge_brand');
    normalized.searchParams.delete('badge_model');
    normalized.searchParams.delete('badge_logo');
    normalized.searchParams.delete('badge_page');
    if (current.page > 1) normalized.searchParams.set('page', String(result.serverPage));
    else normalized.searchParams.delete('page');
    if (normalized.searchParams.has('sort_by')) normalized.searchParams.set('sort_by', result.sort);
    replaceRows(result.rows);
    count.textContent = result.total + ' products';
    empty.hidden = true;
    reset.hidden = true;
    renderControls([], normalized, null);
    pager.innerHTML = result.paginationHTML || '';
    pager.hidden = result.pages < 2;
    for (const link of pager.querySelectorAll('a')) {
      const source = new URL(link.getAttribute('href'), normalized);
      const target = new URL(normalized);
      target.searchParams.delete('page');
      target.searchParams.delete('badge_page');
      const page = Number(source.searchParams.get('page')) || 1;
      if (page > 1) target.searchParams.set('page', String(page));
      link.href = relative(target);
    }
    sort.value = result.sort;
    root.dataset.badgeReady = 'true';
    root.dataset.badgeHubActive = 'false';
    root.dataset.badgeHubLoaded = String(result.rows.length);
    root.dataset.badgeLoaded = String(result.rows.length);
    return normalized;
  };
  const renderBrand = (result, url, brandLink) => {
    const normalized = new URL(url);
    normalized.searchParams.delete('page');
    normalized.searchParams.delete('badge_logo');
    const availableModels = values(result.rows, 'model');
    if (normalized.searchParams.get('badge_model') && !availableModels.includes(normalized.searchParams.get('badge_model'))) {
      normalized.searchParams.delete('badge_model');
      normalized.searchParams.delete('badge_page');
    }
    const current = state(normalized);
    const matched = result.rows.filter(row => matches(row, current));
    const pages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE));
    const page = Math.min(current.page, pages);
    normalized.searchParams.delete('badge_page');
    if (page > 1) normalized.searchParams.set('badge_page', String(page));
    if (normalized.searchParams.has('sort_by')) normalized.searchParams.set('sort_by', result.sort);
    const shown = matched.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    replaceRows(result.rows, shown);
    count.textContent = matched.length + ' products';
    const brandCount = brandLink.querySelector('small');
    if (brandCount) brandCount.textContent = result.total + ' designs';
    empty.hidden = matched.length > 0;
    reset.hidden = false;
    reset.href = relative(change(normalized, 'reset'));
    renderControls(result.rows, normalized, brandLink);
    renderPager(normalized, pages, page, 'brand');
    sort.value = result.sort;
    root.dataset.badgeReady = 'true';
    root.dataset.badgeHubActive = 'true';
    root.dataset.badgeHubLoaded = String(result.rows.length);
    root.dataset.badgeLoaded = String(result.rows.length);
    return normalized;
  };
  const update = async (url, push = true) => {
    if (url.origin !== location.origin || collectionPath(url) !== collectionPath(catalog.dataset.collectionUrl)) return;
    desired = new URL(url);
    const mine = ++serial;
    controller?.abort();
    controller = new AbortController();
    root.setAttribute('aria-busy', 'true');
    root.dataset.badgeHubActive = String(Boolean(state(desired).brand));
    setStatus('Loading products…', false);
    try {
      const current = state(desired);
      let normalized;
      if (current.brand) {
        const link = brandLinkFor(current.brand);
        if (!link) throw new Error('Brand option unavailable');
        const result = await loadBrand(current.brand, effectiveSort(desired), controller.signal);
        if (mine !== serial) return;
        normalized = renderBrand(result, desired, link);
      } else {
        const result = await loadGeneral(desired, controller.signal);
        if (mine !== serial) return;
        normalized = renderGeneral(result, desired);
      }
      if (mine !== serial) return;
      desired = normalized;
      if (push && relative(normalized) !== relative(new URL(location.href))) history.pushState({}, '', normalized);
      else history.replaceState(history.state, '', normalized);
      setStatus('', false);
      root.removeAttribute('aria-busy');
    } catch (error) {
      if (mine !== serial || error.name === 'AbortError') return;
      root.removeAttribute('aria-busy');
      setStatus('Products could not be loaded. Your selection has not been applied.', true);
      root.dataset.badgeReady = 'error';
    }
  };

  root.addEventListener('change', event => {
    if (event.target.matches('[data-badge-hub-field]')) {
      const detail = event.target.closest('details');
      detail.open = false;
      detail.querySelector('summary').focus();
      update(change(desired, event.target.dataset.badgeHubField, event.target.value));
    } else if (event.target === sort && state(desired).brand) {
      update(change(desired, 'sort', sort.value));
    }
  });
  root.addEventListener('click', event => {
    const brandLink = event.target.closest('[data-badge-brand-link]');
    if (brandLink && root.contains(brandLink) && plainClick(event)) {
      event.preventDefault();
      closeMenus(root);
      update(change(desired, 'brand', brandLink.href));
      return;
    }
    const resetLink = event.target.closest('[data-badge-hub-reset], [data-badge-hub-clear]');
    if (resetLink && plainClick(event) && state(desired).brand) {
      event.preventDefault();
      closeMenus(root);
      update(change(desired, 'reset'));
      return;
    }
    const pageLink = event.target.closest('[data-badge-hub-pagination] a, [data-badge-pagination] a');
    if (pageLink && plainClick(event) && state(desired).brand) {
      event.preventDefault();
      closeMenus(root);
      update(new URL(pageLink.href));
    }
  });
  window.addEventListener('popstate', () => {
    if (collectionPath(location) === collectionPath(catalog.dataset.collectionUrl)) update(new URL(location.href), false);
  });
  root.dataset.badgeReady = 'true';
  update(desired, false);
}
function init() {
  document.querySelectorAll('[data-badge-hub]').forEach(initHub);
  document.querySelectorAll('[data-badge-brand-picker]').forEach(root => { if (root.closest('[data-badge-hub]') || root.dataset.badgeBound) return; root.dataset.badgeBound = 'true'; bindMenus(root); });
  document.querySelectorAll('[data-badge-hub-sort]').forEach(form => { if(form.dataset.badgeBound)return; form.dataset.badgeBound='true'; const hub = form.closest('[data-badge-hub]'); form.addEventListener('change', () => { if (hub?.dataset.badgeHubActive === 'true') return; form.requestSubmit(); }); });
  document.querySelectorAll('[data-lds-badge-catalog]').forEach(initCatalog);
}
if (typeof document !== 'undefined') { init(); document.addEventListener('shopify:section:load', init); }
